'use client';
import React from 'react';
import { Box, Stack } from '@mui/material';
import CustomImage from '@components/CustomImage';
import ReactHtmlParser from '@libs/reactHtmlParser';
import ParallaxText from '@components/ParallaxText';
import DynamicButton from '@components/DynamicButton';
import cn from './style.module.scss';

export default function WharfSpaces(props: any) {
  return (
    <Stack
      component="section"
      className={cn.wharfSpacesWrapper}
      id="wharfLivingID"
    >
      <Box className={cn.wharfSpacesInner}>
        <Box className={cn.wharfSpacesBlock}>
          <Box className={cn.wharfSpacesContent}>
            <Box className={cn.wharfSpacesContent__heading}>
              <ParallaxText
                variant="h2"
                animationType="zoomIn"
                animationDuration={500}
              >
                {ReactHtmlParser(props.locale.section['ransomSpacesHeading'])}
              </ParallaxText>
            </Box>
            <Box className={cn.wharfSpacesContent__data}>
              <Box className={cn.wharfDataParagraph}>
                <ParallaxText
                  variant="p"
                  animationType="zoomIn"
                  animationDuration={500}
                >
                  {ReactHtmlParser(props.locale.section['ransomSpacesContent'])}
                </ParallaxText>
              </Box>
              {props.locale.section['ransomSpacesButtonVisible'] ? (
                <Box className={cn.wharfDataButton}>
                  <DynamicButton
                    className={cn.wharfSpacesButton}
                    children={props.locale.section['ransomButton']}
                    scrollToId="wharfRegistrationID"
                  />
                </Box>
              ) : null}
            </Box>
          </Box>
          <Box className={cn.wharfSpacesStory}>
            <Box className={cn.wharfSpacesStory__small}>
              <Box className={cn.wharfStoryElement}>
                <CustomImage
                  src={props.images.ransome_wharf_spaces_theme_one?.src || ''}
                  alt={'BrookGreen Introduction Image'}
                  width={768}
                  height={768}
                />
              </Box>
            </Box>
            <Box className={cn.wharfSpacesStory__big}>
              <Box className={cn.wharfStoryElement}>
                <CustomImage
                  src={props.images.ransome_wharf_spaces_theme_two?.src || ''}
                  alt={'BrookGreen Introduction Image'}
                  width={768}
                  height={768}
                />
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Stack>
  );
}
